export default {
  signup: 'Sign up',
  'signup.buttons.create-account': 'Create Account',
};
